import { createSlice } from '@reduxjs/toolkit'

const defaultState = {
  displayedAds: [],
}

export const ads = createSlice({
  name: 'ads',
  initialState: defaultState,
  reducers: {
    pushAd: (state, action) => {
      state.displayedAds.push(action.payload)
      state.adsLastRefreshedAt = new Date()
    },
    updateLastRefreshTime: (state) => {
      state.adsLastRefreshedAt = new Date()
    },
  },
})

export const { pushAd, updateLastRefreshTime } = ads.actions
